<template>
    <ModalBase @close="cancel" :withContent="true" :maxWidth="'default'">
        <loader :loading="loading"></loader>
        <section>
            <label>{{ $t("plano.saveAsModal.saveAsLabel") }} :</label>
            <input class="nameInput" type="text" v-model="newPlano.name" :class="{ empty: error.name }" />
            <label class="errorMessage" v-if="error.name">{{ $t("common.required") }}</label>
        </section>
        <section>
            <h1>{{ $t("common.campaign") }}</h1>
            <div>
                <p
                    v-for="campaign in listCampaigns"
                    :key="campaign.id"
                    class="brandLogo txtCenter uppercase"
                    :class="{ elementSelected: campaign.id === newPlano.campaign.id }"
                    @click="selectCampaign(campaign);"
                >
                    {{ campaign.name }}
                </p>
            </div>
        </section>
        <footer class="txtCenter">
            <button class="btn" @click="saveNewPlano">{{ $t("common.save") }}</button>
            <button class="btn" @click="cancel">{{ $t("common.cancel") }}</button>
        </footer>
    </ModalBase>
</template>

<script>
import { Context } from "plano_engine";
import plano from "@/services/plano";
import campaign from "@/services/campaign";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import ModalBase from "@/components/modal/ModalBase";
export default {
    data: () => ({
        newPlano: {
            name: undefined,
            campaign: undefined,
            content: undefined,
            zone: undefined
        },
        error: {
            name: undefined
        },
        listCampaigns: []
    }),
    components: { loader, ModalBase },
    mixins: [TryLoadMixin],
    props: {
        plano: {
            type: Object,
            required: true
        }
    },
    methods: {
        async saveNewPlano() {
            this.error.name = undefined;
            if (!this.newPlano.name) {
                this.error.name = true;
                return;
            }
            this.newPlano.content = Context.save();
            const resp = await this.tryLoad(() => plano.savePlanoAs(this.plano.id, this.newPlano));
            this.dialogSuccess(this.$t("saved"));
            this.$emit("close");
            this.$router.push({ path: `/planonext/${resp.id}`, params: { planoId: resp.id } });
        },
        cancel() {
            this.$emit("close");
        },
        async fetchListCampaigns() {
            this.listCampaigns = await this.tryLoad(() => campaign.getAll());
        },
        selectCampaign(campaign) {
            this.newPlano.campaign = campaign;
        }
    },
    created() {
        this.newPlano = { ...this.newPlano, zone: this.plano.zone, campaign: this.plano.campaign };
        this.fetchListCampaigns();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
.brandLogo {
    display: inline-block;
    width: auto;
    border-radius: 0.5rem;
    font-size: 12px !important;
    padding: 10px;
    background-color: #f4f4f4;
    margin: 5px 10px;
    cursor: pointer;
    border: 1px transparent solid;
    &.elementSelected,
    &:hover {
        color: $color4;
        border-color: $color4;
        font-weight: bold;
    }
}
.nameInput {
    font-size: 12px;
    font-family: Roboto, Sans-Serif;
    border: 0px;
    border-bottom: 2px #aaa solid;
    width: 250px;
    &.empty {
        border-color: red;
    }
}
.errorMessage {
    font-style: italic;
    font-size: 11px;
    color: red;
    vertical-align: baseline;
}
</style>



// WEBPACK FOOTER //
// ModalSaveAsPlano.vue?5f8aa65c